import { isEmpty, toNumber } from 'lodash'

const utils = {
    parseMarketPlacePageTaxonomies: taxonomies => {
        const _taxonomies = []
        for (const taxo of taxonomies) {
            const _taxo = {
                status: taxo.status,
                id: toNumber(taxo.id),
                label: taxo.label,
                isSelectable: false,
                hasChild: true,
                children: isEmpty(taxo.clusters) ? [] : utils.parseMarketPlacePageClusters(taxo.clusters),
                parentJsonKeyName: 'provider_' + taxo.second_party_provider_id,
                jsonKey: {
                    ids: [toNumber(taxo.id)],
                    name: 'taxo_' + taxo.id,
                    type: 'SecondPartyCluster',
                    subType: 'taxonomy'
                }
            }
            _taxonomies.push(_taxo)
        }
        return _taxonomies
    },

    parseMarketPlacePageClusters: (clusters, isClusterChild) => {
        const _clusters = []

        for (const cluster of clusters) {
            const hasChild = cluster.hasOwnProperty('children') && !isEmpty(cluster.children)
            const _cluster = {
                status: cluster.status,
                account_status: cluster.account_status,
                id: toNumber(cluster.id),
                label: cluster.label,
                isSelectable: cluster.hasOwnProperty('children'),
                hasChild,
                children: cluster.hasOwnProperty('children') && !isEmpty(cluster.children) ? utils.parseMarketPlacePageClusters(cluster.children, true) : [],
                parentJsonKeyName: isClusterChild ? 'cluster_' + cluster.parent_second_party_cluster_id : 'taxo_' + cluster.second_party_taxonomy_id,
                jsonKey: {
                    ids: [toNumber(cluster.id)],
                    name: 'cluster_' + cluster.id,
                    type: 'SecondPartyCluster',
                    subType: 'cluster'
                }
            }
            _clusters.push(_cluster)
        }
        return _clusters
    }
}

export default utils
